export default "__VITE_ASSET__7v6Ibsbm__"